import { LaneType } from "@deliverr/commons-clients/lib/crossdock/models/Lane";

export const getTitleLabel = (lane: LaneType): string => lane + "Title";
